/* 
these encodeSvgString & svgToImageURL functions in tandem:
- take whatever SVG element you give to them
- convert the SVG into a base64 drawing that is then fed into the src attribute of an 
img element
- said img element is drawn onto a blank canvas and rendered in the background 
- then returns a promise with the the base64 .png url of the canvas element with drawn img element 

basically a screenshot is captured of what the svg image looks like when rendered and that 
screenshot is passed as an image to display

very useful because ReactPDF doesn't understand vanilla svg elements 
but DOES understand .png urls

<svg> => src
*/
export function encodeSvgString(svg) {
  const decoded = decodeURIComponent(encodeURIComponent(svg));
  const b64String = Buffer.from(decoded).toString('base64');
  const imgSource = `data:image/svg+xml;base64,${b64String}`;
  return imgSource;
}
export function svgToImageURL(svgData, renderWidth, renderHeight) {
  const id = 'svg-to-img-url-canvas';
  const canvas = document.createElement('canvas');
  canvas.setAttribute('id', id);
  canvas.setAttribute('style', 'display: none');
  document.body.appendChild(canvas);
  canvas.width = renderWidth;
  canvas.height = renderHeight;
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    throw new Error('no canvas 2d context');
  }

  const img = document.createElement('img');
  img.setAttribute('src', encodeSvgString(svgData));
  return new Promise(res => {
    img.onload = function load() {
      ctx.drawImage(img, 0, 0);
      const url = canvas.toDataURL('image/png', 1.0);
      const el = document.getElementById(id);
      if (el) el.remove();
      res(url);
    };
  });
}